import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79ea432c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard__menu" }
const _hoisted_2 = { class: "user__info" }

import { toRefs } from 'vue';
import BasicNormalSelect from '@components/basic/form-elements/BasicNormalSelect.vue';
import { IonCard, IonText } from '@ionic/vue';
import useUserStore from '@/store/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardInfo',
  setup(__props) {

const userStore = useUserStore();
const { user: userData } = toRefs(userStore.state)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(IonCard), { class: "card__user" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(IonText), { class: "info__text" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('label.Logged user')) + ": ", 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(IonText), { class: "info__text" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(userData)?.first_name) + " " + _toDisplayString(_unref(userData)?.last_name), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode(BasicNormalSelect, {
          elements: _ctx.$i18n.availableLocales,
          translateElements: true,
          ariaLabel: "lang",
          placeholder: "Select lang",
          modelValue: _ctx.$i18n.locale,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.$i18n.locale) = $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('label.Selected language')), 1)
          ]),
          _: 1
        }, 8, ["elements", "modelValue"])
      ]),
      _: 1
    })
  ]))
}
}

})